import { Type } from "@angular/core";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const componentLookup: ComponentMap = {
  input: {
    loader: () => import("./inputs/input/input"),
  },
  code: {
    loader: () => import("./inputs/input-code/input-code"),
  },
  radio: {
    loader: () => import("./inputs/input-radio/input-radio"),
  },
  range: {
    loader: () => import("./inputs/input-range/input-range"),
  },
  select: {
    loader: () => import("./inputs/input-select/input-select"),
  },
  date: {
    loader: () => import("./inputs/input-date-separated/input-date-separated"),
  },
  checkbox: {
    loader: () => import("./inputs/input-checkbox/input-checkbox"),
  },
  array: {
    loader: () => import("./inputs/input-array/input-array"),
  },
  typeahead: {
    loader: () => import("./inputs/input-typeahead/input-typeahead"),
  },
  toggle: {
    loader: () => import("./inputs/input-toggle/input-toggle"),
  },
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type ComponentLoader<T = any> = () => Promise<{ default: Type<T> }>;

type ComponentMap = {
  [key: string]: {
    loader: ComponentLoader;
  };
};
